const getFormattedTime = () => {
  const date = new Date();
  const pad = function (n) {
    let z = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    return String(n).padStart(z, '0');
  };
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  const milliseconds = pad(date.getMilliseconds(), 3);
  return {
    formatted: `${hours}::${minutes}::${seconds}::${milliseconds}`,
    raw: date.getTime() // milliseconds since epoch
  };
};
export { getFormattedTime as default };
